import React, {Component} from 'react'
import axios from 'axios'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import {
    Page,
} from '../components'
import '../styles/question/QuestionPage.css'
import defaultImg from '../images/no-source.png'
import {
    Cell,
    CellBody,
    CellFooter,
    CellsTitle,
    LoadMore
} from 'react-weui';
import config from '../config'
import glImg from '../images/gonglve.jpg'


class QuestionCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
            initialized: false,
        };
    }

    componentDidMount() {
        axios.get(`/api/qa/tutorial/all_category`).then((response) => {
            const {items} = response.data.data
            if (response.data.code === 0) {
                this.setState({
                    results: items,
                    initialized: true,
                });
            }
        });

        // init sharedata
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: '十方教育最全功能介绍',
                desc: '你想要的答案都在这里',
                imgUrl: glImg,
                type: 'link',
                link: window.location.href,
            }
        });
    }

    render() {
        const {initialized} = this.state;
        if (!initialized) {
            return (
                <Page>
                    <div className="question-page-div">
                        <LoadMore loading />
                    </div>
                </Page>
            )
        }

        return (
            <Page>
                <div className="question-page-div">
                    <CellsTitle className="question-title">问题分类</CellsTitle>
                    <div className="question-max-height">
                        {
                            this.state.results.length > 0 ?
                                this.state.results.map((item, i) => {
                                    return (
                                        <Link to={"/question/category/" + item.id} key={item.id}
                                              className="question-border2">

                                            <Cell className="question-border question-content">
                                                <CellBody className="question-font_16 text-overflow">
                                                    {item.name}
                                                </CellBody>
                                                <CellFooter />
                                            </Cell>
                                        </Link>

                                    )
                                })
                                :
                                <div className="no-source-content">
                                    <img src={defaultImg} alt="没有内容"/>
                                    <p>sorry没有找到</p>
                                </div>
                        }
                        <p className="text-center text-minor margin-top">讲师管理后台：{config.ADMIN_BASE_URL}/</p>
                    </div>
                </div>
            </Page>
        );
    }
};

export default connect((state) => ({}))(QuestionCategory)



// WEBPACK FOOTER //
// ./src/pages/QuestionCategory.js